import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import reduxDebounced from 'redux-debounced';

import { isDebug } from 'lib/debug';

import browser from '@openclassrooms/utils/browser';
import currentUser from 'Modules/currentUser/reducer';
import exerciseMiddleware from 'Modules/Exercises/middleware';
import modalReducers from 'Modules/modal/reducers';
import { NAME as MODAL_NAME } from 'Modules/modal/constants/constants';
import { NAME as NOTIFICATIONS_NAME } from 'Modules/notifications/constants/constants';
import notificationsReducers from 'Modules/notifications/reducers';
import onlineStatusReducers from 'Modules/onlineStatus/reducers';
import { ONLINE_STATUS_STATE_KEY } from 'Modules/onlineStatus/constants';
import authMiddleware from 'Modules/auth/middlewares';
import authorizationReducer, { AUTHORIZATION_STATE_KEY } from 'Modules/auth/reducers';
import learningPathReducers, { LEARNING_PATH_STATE_KEY } from 'Modules/learning-path/reducers';
import funnelReducers, { FUNNEL_STATE_KEY } from 'Modules/funnel/reducers';
import paymentInformationsReducers, { SHOP_STATE_KEY } from 'Modules/Shop/reducers';
import paymentInformationsMiddleware from 'Modules/Shop/middleware';

import { reducers as errorReducers, middleware as errorMiddleware } from 'Modules/errors';

import users from './users/reducer';

const reducersObject = {
  currentUser,
  users,
  [MODAL_NAME]: modalReducers,
  [NOTIFICATIONS_NAME]: notificationsReducers,
  [ONLINE_STATUS_STATE_KEY]: onlineStatusReducers,
  [LEARNING_PATH_STATE_KEY]: learningPathReducers,
  [FUNNEL_STATE_KEY]: funnelReducers,
  errors: errorReducers,
  [AUTHORIZATION_STATE_KEY]: authorizationReducer,
  [SHOP_STATE_KEY]: paymentInformationsReducers,
};

export const reducer = combineReducers(reducersObject);

const middlewares = [
  reduxDebounced(),
  reduxThunk,
  exerciseMiddleware,
  ...authMiddleware,
  errorMiddleware,
  paymentInformationsMiddleware,
];

if (isDebug()) {
  const logger = createLogger({
    collapsed: (getState, action, logEntry) => !logEntry.error,
  });
  middlewares.push(logger);
}

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = browser.window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

function createReduxStore() {
  return createStore(reducer, composeEnhancers(applyMiddleware(...middlewares)));
}

export default {
  reducersObject,
  createReduxStore,
};
